import { Organization } from "./Organization"

export class User {
    id: string = ""
    firstName: string = ""
    middleNames: string = ""
    lastName: string = ""
    email: string = ""
    isAdmin: boolean = false
    hasPassword: boolean = false

    soapNoteRecipientEmail: string = "";

    soapNoteTemplate: String = "";

    organizations: Organization[] = [];

    toString() {
        return this.id;
    }

    constructor(init?: Partial<User>) {
        if (!init) {
            return;
        }

        Object.assign(this, init);

        if (init.organizations) {
            this.organizations = init.organizations.map(o => new Organization(o));
        }
    }

    get fullName() {
        return `${this.firstName} ${this.lastName}`.trim();
    }
}
